import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/UI';
import ThemeToggle from '../components/ThemeToggle';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center min-h-[80vh]">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>

      <h1 className="text-9xl font-bold text-red">404</h1>
      <h2 className="text-2xl font-semibold mt-4 mb-2 font-heading">{t('notFound.pageNotFound') as string}</h2>
      <p className="text-text-secondary dark:text-text-primary mb-8">
        {t('notFound.pageNotFoundDescription') as string}
      </p>

      <Link to="/">
        <Button>
          {t('notFound.goBackHome') as string}
        </Button>
      </Link>
    </div>
  );
};

export default NotFoundPage;
